import { observer } from "mobx-react";
import React, { useContext } from "react";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import GroupedEventStatsChart from "@features/offer/desktop/statistics/components/grouped-event-stats/GroupedEventStatsChart";
import { PressureIndexChart } from "@features/offer/shared/statistics";
import { ErrorWrapper } from "@features/offer/shared/statistics";
import { OfferStoreContext } from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

export default observer(function MatchStatistics() {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	if (store.displayStatisticsGroup === StatisticsGroups.LiveStats) {
		return (
			<ErrorWrapper>
				<div className="event__content">
					{store.sportStatisticsStore.filteredMatchStats
						.pressureIndex && (
						<PressureIndexChart
							homeAwayTeams={
								store.sportStatisticsStore.homeAndAwayTeam
							}
							store={store.sportStatisticsStore.pressureIndex}
						/>
					)}
					{store.sportStatisticsStore.filteredMatchStats
						.groupedMatchStatisticsChartData && (
						<GroupedEventStatsChart
							store={store.sportStatisticsStore}
						/>
					)}
				</div>
			</ErrorWrapper>
		);
	}

	return null;
});
